import script from "./WebmailApp.vue?vue&type=script&setup=true&lang=js"
export * from "./WebmailApp.vue?vue&type=script&setup=true&lang=js"

import "./WebmailApp.vue?vue&type=style&index=0&id=6f9d3bb6&lang=less"

const __exports__ = script;

export default __exports__